import { useState, type JSX } from 'react';
import SliderDots from './SliderDots';
import { CarouselContent, SliderContainer } from './styles';
import { BoxProps, Slide } from '@mui/material';
import { Column } from '../../styles';

interface Props extends BoxProps {
    elements: JSX.Element[];
    sliderContentProps?: BoxProps;
    getScrollFactor?: (index: number) => number; // Keep for backwards compatibility but not used
}

const Slider = ({ elements, sliderContentProps, getScrollFactor, ...boxProps }: Props) => {
    const [activeElement, setActiveElement] = useState(0);
    const [slideDirection, setSlideDirection] = useState<'left' | 'right'>('left');

    const handleNext = () => {
        setSlideDirection('left');
        setActiveElement((prev) => Math.min(prev + 1, elements.length - 1));
    };

    const handleBack = () => {
        setSlideDirection('right');
        setActiveElement((prev) => Math.max(prev - 1, 0));
    };

    if (elements.length === 0) return null;

    return (
        <Column>
            <SliderContainer {...boxProps}>
                <Slide direction={slideDirection} in={true} timeout={500} key={activeElement}>
                    <CarouselContent {...sliderContentProps}>
                        {elements[activeElement]}
                    </CarouselContent>
                </Slide>
            </SliderContainer>
            <SliderDots
                stepCount={elements.length}
                activeStep={activeElement}
                handleNext={handleNext}
                handleBack={handleBack}
            />
        </Column>
    );
};

export { Slider };
